import { useMemo } from 'react';

export function useClientPagination<T>(items: T[], page: number, pageSize: number) {
  return useMemo(
    () => ({
      paginatedItems: items.slice((page - 1) * pageSize, page * pageSize),
      totalPages: Math.max(1, Math.ceil(items.length / pageSize)),
    }),
    [items, page, pageSize],
  );
}
